import React, { CSSProperties } from 'react';
import { Modal } from '@mui/material';
import { Sizes } from './index';
import { ModalButton, OverlayText } from '../../style/common';

const ImageModal: React.FC<{
  picURL: string;
  imgWidth?: number | string;
  imgHeight?: number | string;
  imageRealSizes?: Sizes;
  squaredImg?: boolean;
  cornerRadius?: number;
  imageText?: string;
  style?: CSSProperties;
}> = ({ picURL, imageRealSizes, imgWidth, imgHeight = 35, squaredImg = true, cornerRadius, imageText, style }) => {
  const [modalIsOpen, setModalIsOpen] = React.useState<boolean>(false);
  // Custom width in case of big images
  const imgWidthCustom = imgWidth ? imgWidth : squaredImg ? imgHeight : '100%';

  return (
    <>
      <ModalButton
        onClick={() => setModalIsOpen(true)}
        url={picURL}
        data-testid="modal-button"
        style={{ height: imgHeight, width: imgWidthCustom, borderRadius: cornerRadius, ...style }}
      >
        {imageText && <OverlayText>{imageText}</OverlayText>}
      </ModalButton>

      {modalIsOpen && imageRealSizes && (
        <Modal
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          role="presentation"
          open={true}
          onClose={() => setModalIsOpen(false)}
        >
          <img
            alt="User avatar enlarged"
            data-testid="user-avatar"
            src={picURL}
            style={{
              width: 'auto',
              borderRadius: cornerRadius,
              height: imageRealSizes.height,
              maxHeight: '90vh',
            }}
          />
        </Modal>
      )}
    </>
  );
};

export default ImageModal;
